import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { booksKeys } from "@/features/books/queries/booksQueryKeys";
import booksService from "@/features/books/services/booksService";

export function useUnarchiveBook() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (bookId: string) => booksService.unarchiveBook(bookId),
        onError: (error) => {
            const errorMessage = error instanceof Error ? error.message : "Failed to show book";
            toast.error(errorMessage);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: booksKeys.all });
            toast.success("Book is now visible");
        },
    });
}
